module.exports = __webpack_public_path__ + "img/IFishingBoat64_ua.006eac67.webp";